import { Component } from '@angular/core';
import { IonicPage, ModalController, NavController, ToastController, NavParams, AlertController, ViewController} from 'ionic-angular';
import { RestProvider } from '../../providers/rest/rest';
import { HttpClient} from '@angular/common/http';
import { DataProvider } from '../../providers/data/data';

@IonicPage()
@Component({
  selector: 'page-jobs',
  templateUrl: 'jobs.html',
})
export class JobsPage {
  private GetUsers = [];
  private jobs = [];
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private modalCtrl: ModalController,
    public alertCtrl: AlertController,
    private rest: RestProvider,
    private data: DataProvider,
    private toastCtrl: ToastController,
    public httpClient: HttpClient,
    ) {

  }

  ionViewDidLoad() {
    document.getElementById('backmenu').style.display = 'block';
    document.getElementById('backFrom').innerText = '';
    this.data.currentTabName = 'Ажил';
    this.rest.GetUsers(this.data.companyId).subscribe(res => {
      this.GetUsers = res;
    });
    this.rest.jobs(this.data.companyId).subscribe(res => {
      this.jobs = res;
    });

  }
  addJobs(){
    let addJobs = this.modalCtrl.create(
      ModalAddJobsPage,
      { },
      {
        showBackdrop: false,
        enableBackdropDismiss: true
      }
    );
    addJobs.present().catch(err => {

    });
    addJobs.onDidDismiss((data) => {
    });
  }
  addVacation(){
    let addJobs = this.modalCtrl.create(
      ModalAddVacationPage,
      { },
      {
        showBackdrop: false,
        enableBackdropDismiss: true
      }
    );
    addJobs.present().catch(err => {

    });
    addJobs.onDidDismiss((data) => {
    });
  }

  deleteJobs(){

  }
  showToast(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-success"
    });
    toast.present();
  }
  showToast1(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-unsuccess"
    });
    toast.present();
  }
}

@Component({
  template: `
  <ion-header text-center style="height: 50px; text-align: center; background-color: #84dac8;">
    <ion-title>Огноо нэмэх</ion-title>
  </ion-header>
  <ion-content text-center>
    <ion-grid>

      <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-item>
            <ion-label floating>Албан тушаал</ion-label>
            <ion-textarea [(ngModel)]="desc"></ion-textarea>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-3 col-xl-3 col-md-3 col-lg-3>
          <ion-item>
            <button class="myButton" (click)="addJobs()">Нэмэх</button>
          </ion-item>
        </ion-col><ion-col text-center col-sm-3 col-xl-3 col-md-3 col-lg-3>
          <ion-item>
            <button class="myButton" (click)="backto()">Буцах</button>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>
</ion-grid>
</ion-content>
  `
})

export class  ModalAddJobsPage {
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public alertCtrl: AlertController,
    private rest: RestProvider,
    public httpClient: HttpClient,
    private toastCtrl: ToastController,
    private viewCtrl: ViewController,)
  {

  }
  backto(){
    this.viewCtrl.dismiss({});
  }
  showToast(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-success"
    });
    toast.present();
  }
  showToast1(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-unsuccess"
    });
    toast.present();
  }

}

// addVacation ModalPage
@Component({
  template: `
  <ion-header text-center style="height: 50px; text-align: center; background-color: #84dac8;">
    <ion-title>Амралт</ion-title>
  </ion-header>
  <ion-content text-center>
    <ion-grid>

      <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-item>
            <ion-label floating>Эхлэх хугацаа</ion-label>
            <!--<ion-textarea [(ngModel)]="desc"></ion-textarea>-->
            <ion-datetime displayFormat="YYYY/MM/DD" [(ngModel)]="begin_day"></ion-datetime>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-item>
            <ion-label floating>Эхлэх хугацаа</ion-label>
            <!--<ion-textarea [(ngModel)]="desc"></ion-textarea>-->
            <ion-datetime displayFormat="YYYY/MM/DD" [(ngModel)]="end_day"></ion-datetime>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-item>
            <ion-label floating>Амрах хоног</ion-label>
            <ion-textarea [(ngModel)]="holidayDate"></ion-textarea>
            <!--<ion-datetime displayFormat="YYYY/MM/DD" [(ngModel)]="holidayDate"></ion-datetime>-->
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-item>
            <ion-label floating>Тайлбар</ion-label>
            <ion-textarea [(ngModel)]="desc"></ion-textarea>
            <!--<ion-datetime displayFormat="YYYY/MM/DD" [(ngModel)]="begin_day"></ion-datetime>-->
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-3 col-xl-3 col-md-3 col-lg-3>
          <ion-item>
            <button class="myButton" (click)="addJobs()">Нэмэх</button>
            <button class="myButton" (click)="addJobs()">Нэмэх</button>
          </ion-item>
        </ion-col><ion-col text-center col-sm-3 col-xl-3 col-md-3 col-lg-3>
          <ion-item>
            <button class="myButton" (click)="backto()">Буцах</button>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>
</ion-grid>
</ion-content>
  `
})

export class  ModalAddVacationPage {
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public alertCtrl: AlertController,
    private rest: RestProvider,
    public httpClient: HttpClient,
    private toastCtrl: ToastController,
    private viewCtrl: ViewController,)
  {

  }
  backto(){
    this.viewCtrl.dismiss({});
  }
  showToast(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-success"
    });
    toast.present();
  }
  showToast1(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-unsuccess"
    });
    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/jobs/jobs.ts